import { RenderProps, useToast as useChakraToast } from '@chakra-ui/react'
import React from 'react'
import { Alert } from '../Alert'
import { Toast as IToast } from './types'

const useToast = (props?: IToast) => {
  const toast = useChakraToast(props)
  const {
    title: defaultTitle,
    description: defaultDescription,
    status: defaultStatus,
    isClosable: defaultIsClosable,
    duration: defaultDuration,
    showIcon: defaultShowIcon,
  } = props || {
    title: undefined,
    description: undefined,
    variant: undefined,
    status: undefined,
    isClosable: undefined,
    position: undefined,
    duration: undefined,
    showIcon: undefined,
  }

  // null is actually a truthy value here representing Infinity, which makes our logic here kind of weird
  // duration and defaultDuration are evaluated separately to maintain the override capability
  const determineDuration = duration => {
    if (duration) return duration
    if (duration === null) return null
    if (defaultDuration) return defaultDuration
    if (defaultDuration === null) return null
    return undefined
  }

  const getStyles = variant => {
    const baseStyles = {
      width: 340,
      boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)',
    }
    if (variant === 'solid')
      return {
        ...baseStyles,
        color: 'black',
      }
    return { ...baseStyles, bg: 'white' }
  }

  return ({
    title,
    description,
    variant,
    status,
    isClosable,
    position,
    duration,
    showIcon,
  }: IToast) =>
    toast({
      position: position || 'top-right',
      duration: determineDuration(duration),
      render: ({
        id,
        onClose,
      }: {
        // weird issue here where RenderProps['id'] is equal to string | number but id can only be a string. Submitted a ticket for it.
        id: string
        onClose: RenderProps['onClose']
      }) => {
        return (
          <Alert
            id={id}
            dismiss={onClose}
            title={title || defaultTitle}
            description={description || defaultDescription}
            variant={variant || 'left-accent'}
            status={status || defaultStatus}
            isClosable={isClosable ?? defaultIsClosable}
            showIcon={showIcon ?? defaultShowIcon}
            direction="column"
            sx={getStyles(variant || 'left-accent')}
          />
        )
      },
    })
}

export default useToast
